import { CoursePlanType } from "../../types/CoursePlan";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { get, post, put } from "../../utils/axios-config";
import { COURSE_PLAN } from "../../utils/constants";

export const createCoursePlan = async (data: CoursePlanType) => await post<CoursePlanType, string>(COURSE_PLAN, data);
export const updateCoursePlan = async (data: CoursePlanType) => await put<CoursePlanType, string>(COURSE_PLAN, data);

export const getCoursePlans = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });

    if (data?.IdCourse) {
        queryParams.append('IdCourse', data.IdCourse);
    }

    if (data?.IdAcademicYear) {
        queryParams.append('IdAcademicYear', data.IdAcademicYear);
    }
    if (data?.AcademicYear) {
        queryParams.append('AcademicYear', data?.AcademicYear.toString());
    }

    const url = `${COURSE_PLAN}?${queryParams.toString()}`;
    return await get<PagedResultsType<CoursePlanType>>(url)
};